import React from "react";

import { Routes, Route } from "react-router-dom";

import Login from "./Login";
import Layout2 from "../../layout2/Layout2";
import NotFound from "../notFound/NotFound";
import ForgetPassword from "./forgotPassword/ForgetPassword";
import OtpVerification from "./otpVerification/OtpVerification";
import ResetPassword from "./resetPassword/ResetPassword";
import EmailVerification from "./forgotPassword/EmailVerification";

const index = () => {
  return (
    <Routes>
      <Route element={<Layout2 />}>
        <Route path="/" element={<Login />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:userId" element={<ResetPassword />} />
        <Route path="/email-verification/:token" element={<EmailVerification />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default index;
